import { URL_SEARCH_PARAMS as _URL_SEARCH_PARAMS } from "repoV2/features/Common/modules/URLsNRouting/URLsNRouting.constants";
/**
 * @deprecated
 * Use repoV2/features/Common/modules/URLsNRouting/URLsNRouting.constants.ts
 */
export const URL_SEARCH_PARAMS = _URL_SEARCH_PARAMS;
